import React from 'react';
import LabelWithTooltip from '../../../LabelWithTooltip';
import { classifications, normalizeClassification } from '../constants';

const Classification = ({ classification }) => {
  const normalizedClassification = normalizeClassification(classification);
  const classificationData = normalizedClassification
    ? classifications[normalizedClassification]
    : null;

  /**
   *  TODO: PROBABLY NEEDS DESIGN DISCUSSIONS IN THE FUTURE.
   * For now lets display the label regardless if its a match with a classification or not.
   */
  if (!classificationData) {
    return (
      <div className="classification classification-unknown">
        <LabelWithTooltip name={classification} />
      </div>
    );
  }

  return (
    <div className={`classification ${classificationData.class}`}>
      <LabelWithTooltip name={classificationData.label} />
    </div>
  );
};

export default Classification;
